import { render, staticRenderFns } from "./GreenOperationDocumentsHistory.vue?vue&type=template&id=4d2c3f80&scoped=true&"
import script from "./GreenOperationDocumentsHistory.vue?vue&type=script&lang=js&"
export * from "./GreenOperationDocumentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./GreenOperationDocumentsHistory.vue?vue&type=style&index=0&id=4d2c3f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c3f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2c3f80')) {
      api.createRecord('4d2c3f80', component.options)
    } else {
      api.reload('4d2c3f80', component.options)
    }
    module.hot.accept("./GreenOperationDocumentsHistory.vue?vue&type=template&id=4d2c3f80&scoped=true&", function () {
      api.rerender('4d2c3f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/greenOperation/GreenOperationDocumentsHistory.vue"
export default component.exports